import { Injectable } from '@angular/core';
import { SurveyService } from '../../../../../core/services/survey/survey.service';
import { VariablesService } from '../../../../../core/services/survey/variables.service';
import { FindOfficesApiService, NrdsOfficesApiService } from '@tangilla/tg-ng-core';
import { RequestParameters } from '@tangilla/tg-ng-models';

@Injectable({
    providedIn: 'root'
})
export class OfficeSearchDrSearchWidgetService {
    affiliatedOfficeSearch = false;
    nrdsSearch = false;

    constructor(private surveyService: SurveyService,
        private variablesService: VariablesService,
        public findOfficesApiService: FindOfficesApiService,
        public nrdsOfficesApiService: NrdsOfficesApiService
    ) {
    }

    async getDrOffices(officeBody?: any) {
        const licenseNumber = this.surveyService.personRelationships.find(r => r.is_main_relationship === true)?.license_number;

        const queryParamsFindOffices = {broker_license: licenseNumber}

        const queryParamsNrdsOffices = this.getQueryParamsFindOFfices(officeBody)
        const parametersFindOffices = (new RequestParameters(null)).setAdditionalFields(queryParamsFindOffices);
        const parametersNrdsOffices = (new RequestParameters(null)).setAdditionalFields(queryParamsNrdsOffices);

        const resultFindOffices = this.getFindOffices(parametersFindOffices);
        const resultNrdsOffices = this.getNrdsOfficesApiService(parametersNrdsOffices);
        let brokerOffices: any[] = [];

        if (resultFindOffices) {
            await resultFindOffices.subscribe({
              next: (data: any) => {
                for(const office of data){
                    brokerOffices.push(office.office_nrds_id)
                }
              },
              error: (error: any) => {
              }
            });
        }
        return {brokerOffices, resultNrdsOffices};
    }

    getQueryParamsFindOFfices(officeBody?: any){
        let params = {};

        if (officeBody.city) {
            params = {
                ...params,
                city: officeBody.city
            }
        }
        params = {
            ...params,
            state: officeBody.state ? officeBody.state : this.variablesService.state,
            business_name: officeBody.office_search
        }
        return params
    }


    getFindOffices(parameters: any) {
        return this.findOfficesApiService.getAll(parameters);
    }
    getNrdsOfficesApiService(parameters: any){
        return this.nrdsOfficesApiService.getAll(parameters);
    }

}


